import {Injectable} from '@angular/core';
import {AppService} from './app.service';
import {Router} from '@angular/router';

interface MedalliaWindow {
  KAMPYLE_ONSITE_SDK: {
    updatePageView: () => void;
  }
}

interface RequiredFields {
  brandName: string;
  countryCode: string;
  isAgent: boolean;
  personId: string;
  registrationCompletion: boolean;
  url: string;
  userEmail: string;
  userName: string;
  userRole: string;
  customerTaxID: string;
  optIn: boolean;
}

export interface TrackingCommonData {
  bookingDestinTransportMode: string;
  bookingOriginTransportMode: string;
}

type Survey = 'tracking' | 'booking' | 'quotation' | 'schedule'

interface BookingData {
  bookingType: 'credit'
  containerType: string;
  vas: boolean
}

interface BookingInstPaymentData {
  bookingType: 'without credit'
  bookingValue: string
  containerType: string;
}

interface TrackingData {
  containerType: string;
}

interface ScheduleDeliveryData {
  scheduleConfirmation: true
}

type AllSurveyData = BookingData | BookingInstPaymentData | TrackingData | ScheduleDeliveryData

type AllKeys = keyof BookingData |
  keyof BookingInstPaymentData |
  keyof TrackingData |
  keyof ScheduleDeliveryData |
  keyof RequiredFields |
  keyof TrackingCommonData

type SurveyData<T> = {
  tracking: TrackingCommonData,
  extraParams: T,
}

@Injectable({
  providedIn: 'root'
})
export class MedalliaService {
  private optInValue = false;

  constructor(
    private appService: AppService,
    private router: Router,
  ) {}


  private getRequiredFields = () => {
    const user = this.appService.UsuarioLogado;
    const obj: RequiredFields = {
      brandName: 'Aliança',
      countryCode: 'BR',
      isAgent: user.perfil.admin,
      personId: user.usuarioID.toString(),
      registrationCompletion: true,
      url: this.router.url,
      userEmail: user.email,
      userName: user.nome,
      userRole: user.perfil.descricao,
      customerTaxID: user.cnpjs.join(','),
      optIn: this.optInValue,
    }
    return obj
  }

  clearVariables() {
    const allKeys: AllKeys[] = [
      'brandName',
      'countryCode',
      'isAgent',
      'personId',
      'registrationCompletion',
      'url',
      'userEmail',
      'userName',
      'userRole',
      'customerTaxID',
      'bookingDestinTransportMode',
      'bookingOriginTransportMode',
      'bookingType',
      'containerType',
      'vas',
      'bookingValue',
      'scheduleConfirmation',
      'optIn',
    ];
    allKeys.forEach(key => sessionStorage.removeItem(key))
  }

  updateOptInValue(optInValue: boolean) {
    this.optInValue = optInValue
  }

  updatePageView() {
    const safeWindow = window as unknown as Window & Partial<MedalliaWindow>
    if (safeWindow?.KAMPYLE_ONSITE_SDK?.updatePageView) {
      safeWindow.KAMPYLE_ONSITE_SDK.updatePageView();
    }
  }

  emitSurvey(survey: 'tracking', data: SurveyData<TrackingData>): void
  emitSurvey(survey: 'booking', data: SurveyData<BookingData>): void
  emitSurvey(survey: 'quotation', data: SurveyData<BookingInstPaymentData>): void
  emitSurvey(survey: 'schedule', data: SurveyData<ScheduleDeliveryData>): void
  emitSurvey(_survey: Survey, data: SurveyData<AllSurveyData>): void {
    const {tracking, extraParams} = data

    const finalObj = {...this.getRequiredFields(), ...tracking, ...extraParams}
    const entries = Object.entries(finalObj)
    this.clearVariables()
    entries.forEach(entry => {
      sessionStorage.setItem(entry[0], entry[1].toString())
    })
    this.updatePageView()
  }
}
